
import React from 'react';
import { CardContent } from '@/components/ui/card';
import { Loader2 } from 'lucide-react';

const LoadingState: React.FC = () => {
  return (
    <CardContent className="flex flex-col items-center justify-center flex-1">
      <Loader2 className="h-10 w-10 animate-spin text-glowingTeal mb-4" />
      <p className="text-center text-gray-500">
        Initializing travel assistant...
      </p>
    </CardContent>
  );
};

export default LoadingState;
